import React from 'react';

import classNames from 'classnames';

import { Button } from '../../../../components/Button';

export const ButtonCurrencyBlock = ({ onClick, title, items }) => {
  return (
    <div className="quote-currency__button-list">
      {items.map((name) => (
        <Button
          key={name}
          className={classNames('regular-button quote-currency__button', {
            'regular-button--active': title === name,
          })}
          title={name}
          onClick={onClick}
          hasValue
        />
      ))}
    </div>
  );
};
